module.exports = __webpack_public_path__ + "static/media/maps-marker.8fe78918.svg";